module.exports = __webpack_public_path__ + "static/flags/RQ-8c34479ed2cd357571606445b970699a.gif";